var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5455",
    "data-name": "Group 5455",
    transform: "translate(-500 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(500 245)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M17.674,50.82h6.512V47.8A3.492,3.492,0,0,0,20.7,44.308H3.488A3.492,3.492,0,0,0,0,47.8V60.82a3.492,3.492,0,0,0,3.488,3.488H20.7a3.492,3.492,0,0,0,3.488-3.488V57.8H17.674a3.488,3.488,0,1,1,0-6.977Z",
    transform: "translate(513 215.692)",
    fill: "#f3f6fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M331.939,211.692a2.093,2.093,0,0,0,0,4.186h6.512v-4.186h-6.512Zm.93,2.791h-.93a.7.7,0,0,1,0-1.4h.93a.7.7,0,1,1,0,1.4Z",
    transform: "translate(198.735 56.215)",
    fill: "#f3f6fd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarning);
export default __webpack_public_path__ + "static/media/earning.ee9f6cc058b4ddf0e0b29cad0d7794b2.svg";
export { ForwardRef as ReactComponent };